"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendContactFormEmail = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _urls = require("./urls");

var sendContactFormEmail = function sendContactFormEmail(params) {
  var businessType = params.businessType,
      businessId = params.businessId,
      locationId = params.locationId,
      name = params.name,
      email = params.email,
      emailSubject = params.emailSubject,
      message = params.message,
      contactOptIn = params.contactOptIn;
  var url = (0, _urls.getServerURL)();
  var fullUrl = "".concat(url, "businesses/").concat(businessType, "s/").concat(businessId, "/locations/").concat(locationId, "/email/");
  return _axios["default"].post(fullUrl, {
    contact_name: name,
    contact_email: email,
    contact_message: message,
    contact_opt_in: contactOptIn,
    email_subject: emailSubject
  });
};

exports.sendContactFormEmail = sendContactFormEmail;